import React from 'react';
import { Link } from 'react-router-dom';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import withWidth, { isWidthDown } from '@material-ui/core/withWidth';

class PageTabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      currentTab: window.location.pathname,
    };
  }

  handleChange = (value) => {
    this.setState({ value });
  };

  render() {
    const { classes, width, isLoggedIn } = this.props;
    const isScrollable = isWidthDown('sm', width);
    return (
      <div className={classes.container}>
        <Tabs
          value={this.state.currentTab}
          onChange={this.handleChange}
          variant={isScrollable ? 'scrollable' : 'standard'}
          TabIndicatorProps={{
            style: {
              display: 'none',
            },
          }}
        >
          <Tab
            className={classes.tab}
            classes={{ selected: classes.tabSelected }}
            value={'/search'}
            label="Search"
            to="/search"
            component={Link}
          />
          <Tab
            className={classes.tab}
            classes={{ selected: classes.tabSelected }}
            value={'/basket'}
            label="Cart"
            to="/basket"
            component={Link}
          />
          <Tab
            className={classes.tab}
            classes={{ selected: classes.tabSelected }}
            disabled={!isLoggedIn}
            value={'/orders'}
            label="Orders"
            to="/orders"
            component={Link}
          />
          <Tab
            className={classes.tab}
            classes={{ selected: classes.tabSelected }}
            disabled={!isLoggedIn}
            value={'/dispatch'}
            label="Dispatch"
            to="/dispatch"
            component={Link}
          />
          <Tab
            className={classes.tab}
            classes={{ selected: classes.tabSelected }}
            disabled={!isLoggedIn}
            value={'/balance'}
            label="Balance"
            to="/balance"
            component={Link}
          />
          <Tab
            className={classes.tab}
            classes={{ selected: classes.tabSelected }}
            value={'/offers'}
            label="Offers"
            to="/offers"
            component={Link}
          />
        </Tabs>
      </div>
    );
  }
}

const styles = (theme) => ({
  container: {
    display: 'flex',
    alignItems: 'baseline',
    backgroundColor: theme.palette.custom.pageTabs.tab,
    color: '#fff',
    position: 'relative',
    justifyContent: 'center',
    marginTop: '2px',
    [theme.breakpoints.down('sm')]: {},
  },
  button: {
    position: 'absolute',
    top: '9px',
    right: '24px',
    marginLeft: 'auto',
    [theme.breakpoints.down('sm')]: {
      display: 'none',
    },
  },
  tab: {
    opacity: 1,
    borderLeft: '1px solid white',
    borderRight: '1px solid white',
    '&:last-child': {
      borderRight: 'none',
    },
    '&:first-child': {
      borderLeft: 'none',
    },
  },
  tabSelected: {
    backgroundColor: theme.palette.custom.pageTabs.tabSelected,
    color: '#fff',
  },
});

export default withWidth()(withStyles(styles)(PageTabs));
